module.exports = __webpack_public_path__ + "static/media/manual-gearbox-stick-shift.ea3538c3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/manual-gearbox-stick-shift.jpg
// module id = 1278
// module chunks = 0